<template>
    <div>
      <!--下载条目-->
      <div style="height: 60px;">
        <!--下载名称-->
        <div style="float: left; line-height: 60px; font-size: 18px; margin-left: 30px">
          <a @click="handleOpen">{{downloadItem.download_title}}</a>
        </div>
        <!--下载按钮-->
        <div style="float: right; line-height: 60px; margin-right: 30px">
          <el-button @click="getDownloadLink">下载</el-button>
        </div>
      </div>
      <!--分割线-->
      <el-divider></el-divider>

      <!--下载对话框-->
      <el-dialog title="下载详情" :visible.sync="dialogVisible" width="50%">
        <!--下载表格-->
        <el-table :data="gridData"
                  :cell-class-name="tableItemCenter" header-cell-class-name="textCenter" class="table-font">
          <!--第一列-->
          <el-table-column property="item" label="项目" width="250"></el-table-column>
          <!--第二列-->
          <el-table-column property="description" label="描述">
            <!--eslint-disable-next-line vue/no-unused-vars-->
            <template slot-scope="scope">
              <!--文字描述-->
              <span v-if="scope.row.item === '文件描述'"><span v-html="scope.row.description"></span></span>
              <span v-if="scope.row.item === '文件类型'"><el-tag type="danger">{{scope.row.description}}</el-tag></span>
              <span v-if="scope.row.item !== '文件类型' && scope.row.item !== '文件描述'">{{scope.row.description}}</span>
              <!--操作行-->
              <span v-if="scope.row.item === '操作'">
              <!--下载按钮-->
              <el-button type="primary" plain @click="getDownloadLink">
                下载<i class="el-icon-download el-icon--right"></i>
              </el-button>
            </span>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
      </el-dialog>
    </div>
</template>

<script>
import { getDownloadLinkUtil } from '@/utils'
export default {
  name: 'ProductDownload',
  props: {
    downloadItem: {
      type: Object,
      require: true
    }
  },
  data () {
    return {
      dialogVisible: false,
      gridData: [
        {
          item: '文件名称',
          description: ''
        },
        {
          item: '文件类型',
          description: ''
        },
        {
          item: '文件大小',
          description: ''
        },
        {
          item: '已下载次数',
          description: ''
        },
        {
          item: '操作',
          description: ''
        },
        {
          item: '文件描述',
          description: ''
        }
      ]
    }
  },
  methods: {
    tableItemCenter ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return 'textCenter'
      }
    },
    handleOpen () {
      this.dialogVisible = true
      this.gridData[0].description = this.downloadItem.download_title
      this.gridData[1].description = this.downloadItem.download_type === null ? '无' : this.downloadItem.download_type
      this.gridData[2].description = this.downloadItem.download_size
      this.gridData[3].description = this.downloadItem.download_times + ' 次'
      this.gridData[5].description =
        (this.downloadItem.download_intro === null || this.downloadItem.download_intro === '')
          ? '无' : this.downloadItem.download_intro
    },
    getDownloadLink () {
      getDownloadLinkUtil(this.downloadItem.download_id)
    }
  }
}
</script>

<style>
.el-divider--horizontal {
  margin: 5px 0;
}
.el-table .textCenter {
  text-align: center;
}
.table-font {
  font-size: 16px;
}
</style>
